module.exports = __webpack_public_path__ + "static/media/foto1.f7816ec2.png";